import React from "react";
import "./tableWrapper.scss";


class TableWrapper extends React.Component{
    render(){
    return(
        <div data-columns={this.props.columns} className="table-wrapper">
            {this.props.children}
        </div>
    )
    }
}

export default TableWrapper;